document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector("[data-hero-carousel]");
  if (!container) return;

  const windowEl = container.querySelector(".carousel-window");
  const set1 = container.querySelector(".set-1");
  const set2 = container.querySelector(".set-2");

  if (!windowEl || !set1 || !set2) return;

  let currentSet = 0;
  let slideWidth = 0;

  function updateWidth() {
    slideWidth = windowEl.offsetWidth;

    set1.style.transition = "none";
    set2.style.transition = "none";

    set1.style.transform = "translateX(0)";
    set2.style.transform = `translateX(${slideWidth}px)`;
  }

  function animateCarousel() {
    const outgoing = currentSet === 0 ? set1 : set2;
    const incoming = currentSet === 0 ? set2 : set1;

    /* PHASE 1 — current exits to RIGHT */
    outgoing.style.transition = "transform 0.8s ease-in-out";
    outgoing.style.transform = `translateX(${slideWidth}px)`;

    /* PHASE 2 — new comes from RIGHT */
    setTimeout(() => {
      incoming.style.transition = "none";
      incoming.style.transform = `translateX(${slideWidth}px)`;

      requestAnimationFrame(() => {
        incoming.style.transition = "transform 0.8s ease-in-out";
        incoming.style.transform = "translateX(0)";
      });
    }, 800);

    currentSet = 1 - currentSet;
  }

  updateWidth();
  window.addEventListener("resize", updateWidth);
  setInterval(animateCarousel, 2400); // exit + enter timing
});


